import ApiClient from '../ApiClient';

class WebChannel extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  async createCustom(data) {
    // Debug log to inspect request URL and payload before sending
    try {
      console.log('[WebChannel] POST', `${this.url}/create_custom`, data);
      const responses = await axios.post(`${this.url}/create_custom`, data);
      console.log('[WebChannel] responses', responses);
      return responses;
    } catch (error) {
      console.error('[WebChannel] createCustom error', error);
      if (error?.response) {
        console.error('[WebChannel] createCustom error response:', error.response);
      }
      throw error;
    }
  }
}

export default new WebChannel();
